import { falAngleRight } from 'shared/@generated/icons/falAngleRight';
import { View } from 'react-native';
import { Props } from 'shared/@types';
import { H1, H2 } from 'shared/components/title';
import { useTranslation } from 'react-i18next';
import { staticImage } from 'shared/library/static-images';
import { Image } from 'shared/components/image';
import { Text } from 'shared/components/text';
import { usePartners } from 'shared/library/partners';
import { Button } from 'shared/components/button';

interface PetInsuranceScreenProps extends Props {}

const PetInsuranceScreen = ({}: PetInsuranceScreenProps) => {
  const { insurancePartner } = usePartners();
  const { t } = useTranslation('screens');

  return (
    <>
      <View className={'items-center p-3 md:py-12'}>
        <Image
          src={insurancePartner.image}
          alt={insurancePartner.name}
          containerClassName={'aspect-3/1 w-32'}
          imageClassName={'object-contain'}
          priority={true}
        />

        <Text
          className={
            'text-brand-brown-dark z-10 mx-auto max-w-lg text-center text-5xl font-black md:text-7xl'
          }
        >
          {t('pet_insurance.protect_what_matters_most')}
        </Text>

        <Text
          className={
            'text-brand-brown-dark z-10 mx-auto mt-3 max-w-lg text-center text-lg font-semibold md:text-xl'
          }
        >
          {t('pet_insurance.protect_what_matters_most_description', {
            partner: insurancePartner.name,
          })}
        </Text>

        <View className={'mt-6 w-full gap-1.5 md:mt-12 md:w-auto md:flex-row md:gap-3'}>
          <Button
            text={t('pet_insurance.dog_insurance')}
            icon={falAngleRight}
            color={'brown'}
            href={insurancePartner.dogInsuranceUrl}
            openInNewTab={true}
          />

          <Button
            text={t('pet_insurance.cat_insurance')}
            icon={falAngleRight}
            color={'brown'}
            href={insurancePartner.catInsuranceUrl}
            openInNewTab={true}
          />
        </View>
      </View>

      <View className={'p-3 md:p-6 md:py-12'}>
        <View className={`mx-auto w-full max-w-screen-xl`}>
          <View className={'gap-6 md:flex-row-reverse lg:gap-20'}>
            <View className={'md:w-2/5'}>
              <Image
                src={staticImage('puppy-and-kid-playing-in-snow')}
                alt={t('pet_insurance.image_alt')}
                containerClassName={'aspect-square w-full'}
                imageClassName={'rounded object-cover md:rounded-xl'}
                priority={true}
                sizeType={'large'}
                aspectRatio={1}
              />
            </View>

            <View className={'flex-1'}>
              <H1
                title={t('pet_insurance.title')}
                subtitle={t('pet_insurance.description', {
                  partner: insurancePartner.name,
                })}
                marginTop={false}
                marginBottom={false}
              />

              <H2
                title={t('pet_insurance.why_insure_your_pet')}
                subtitle={t('pet_insurance.why_insure_your_pet_description', {
                  partner: insurancePartner.name,
                })}
              />
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export { PetInsuranceScreen };
export type { PetInsuranceScreenProps };
